export const getCourierInterfaceSettingsModel = (data = {}) => {
    return {
        HideFinishButtonInCourierApp: data.hideFinishButtonInCourierApp,
        MultiSelectionInCourierApp: data.multiSelectionInCourierApp,
        ShowPODScreenInCourierApp: data.showPODScreenInCourierApp,
        UseAddressForNavigation: data.useAddressForNavigation,
        EnableCollectOrdersStepAtPickup: data.enableCollectOrdersStepAtPickup,
        RemoveClosedOrdersFromCycle: data.removeClosedOrdersFromCycle,
    };
}